module.exports = __webpack_public_path__ + "img/icon62.0c450e8f.png";